import React from "react";
import ReactDOM from "react-dom/client";

import "@/styles/globals.css";

// Initialise i18n before any component renders. Side-effect import is
// enough — the bootstrap module calls `i18n.init(...)` at module load.
import "@/i18n";

import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root not found");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
